(function () {
  'use strict';

  // ----- Mobile menu -----
  var menu = document.getElementById('mobileMenu');
  var burger = document.getElementById('burger');
  var mmClose = document.getElementById('mmClose');
  if (menu && burger) burger.addEventListener('click', function () { menu.classList.add('open'); });
  if (menu && mmClose) mmClose.addEventListener('click', function () { menu.classList.remove('open'); });
  if (menu) menu.querySelectorAll('a').forEach(function (a) {
    a.addEventListener('click', function () { menu.classList.remove('open'); });
  });

  // ----- Language toggle (visual only) -----
  var lang = document.getElementById('lang');
  if (lang) lang.addEventListener('click', function () {
    lang.textContent = lang.textContent.trim() === 'EN · ع' ? 'ع · EN' : 'EN · ع';
  });

  // ----- Hero shade picker -----
  var dots = document.querySelectorAll('.shade-dot');
  var s1 = document.getElementById('gStop1');
  var s2 = document.getElementById('gStop2');
  var s3 = document.getElementById('gStop3');
  var shadeName = document.getElementById('shadeName');
  if (dots.length) {
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        dots.forEach(function (d) { d.setAttribute('aria-pressed', 'false'); });
        dot.setAttribute('aria-pressed', 'true');
        // Recolor the SVG lipgloss only when it's the hero visual
        if (s1 && s2 && s3) {
          s1.setAttribute('stop-color', dot.dataset.s1);
          s2.setAttribute('stop-color', dot.dataset.s2);
          s3.setAttribute('stop-color', dot.dataset.s3);
        }
        if (shadeName) shadeName.textContent = dot.dataset.name;
      });
    });
  }

  // ----- Wish list toggles -----
  document.querySelectorAll('.wish-btn').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      btn.setAttribute('aria-pressed', btn.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
    });
  });

  // ----- Ambassador split calculator -----
  var splitRange = document.getElementById('splitRange');
  if (splitRange) {
    var youKeep = document.getElementById('youKeep');
    var audSave = document.getElementById('audSave');
    var calcNote = document.getElementById('calcNote');
    var update = function () {
      var give = parseInt(splitRange.value, 10);   // % of your commission passed to audience
      var keep = 100 - give;                        // % of your commission you keep
      youKeep.textContent = keep + '%';
      audSave.textContent = give + '%';
      var note = 'Balanced: a solid cut for you, a real reason for them to buy.';
      if (give === 0) note = 'Keep your whole commission — every bit is yours.';
      else if (give >= 70) note = 'Big incentive for them — great for a launch or a push.';
      else if (give <= 20) note = 'Mostly yours, with a small thank-you for your audience.';
      calcNote.textContent = note;
    };
    splitRange.addEventListener('input', update);
    update();
  }

  // ----- Product page: swatches, variant + image switching -----
  var pdpForm = document.getElementById('pdpForm');
  var mainImg = document.getElementById('pdpMainImage');

  if (pdpForm) {
    var variantsEl = document.getElementById('pdpVariants');
    var variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];
    var idInput = document.getElementById('pdpVariantId');
    var priceEl = document.getElementById('pdpPrice');
    var addBtn = document.getElementById('pdpAddBtn');
    var optionRows = pdpForm.querySelectorAll('.pdp-option');

    var selectedOptions = function () {
      var opts = [];
      optionRows.forEach(function (row) {
        var active = row.querySelector('.pdp-swatch.active');
        opts[parseInt(row.dataset.optionIndex, 10)] = active ? active.dataset.value : null;
      });
      return opts;
    };

    var refresh = function (clickedSwatch) {
      var sel = selectedOptions();
      var match = variants.find(function (v) {
        return v.options.length === sel.length && v.options.every(function (o, i) { return o === sel[i]; });
      });
      // Swap image: prefer the matched variant's image, else the clicked swatch's image
      var newImg = (match && match.image) || (clickedSwatch && clickedSwatch.dataset.variantImage);
      if (mainImg && newImg) {
        mainImg.src = newImg;
        document.querySelectorAll('.pdp-thumb').forEach(function (t) { t.classList.remove('active'); });
      }
      if (!match) return;
      if (idInput) idInput.value = match.id;
      if (priceEl) priceEl.textContent = match.price;
      if (addBtn) {
        addBtn.disabled = !match.available;
        addBtn.textContent = match.available ? addBtn.dataset.add : addBtn.dataset.sold;
      }
    };

    pdpForm.querySelectorAll('.pdp-swatch').forEach(function (sw) {
      sw.addEventListener('click', function () {
        var row = sw.closest('.pdp-option');
        row.querySelectorAll('.pdp-swatch').forEach(function (s) { s.classList.remove('active'); });
        sw.classList.add('active');
        var label = row.querySelector('.pdp-option-value');
        if (label) label.textContent = sw.dataset.value;
        refresh(sw);
      });
    });
  }

  // ----- Product page: thumbnail gallery -----
  document.querySelectorAll('.pdp-thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      if (mainImg) mainImg.src = thumb.dataset.full;
      document.querySelectorAll('.pdp-thumb').forEach(function (t) { t.classList.remove('active'); });
      thumb.classList.add('active');
    });
  });
})();
